import {Tab, Tabs} from '@mui/material';
import React, {useMemo, useState} from 'react';
import {filterBySelectOption} from '../../components/interchanges/data';
import PropTypes from 'prop-types';
import {TabContext, TabPanel} from "@mui/lab";
import BuyerSpaceUsageReport from '../spaceUsage/BuyerSpaceUsageReport';
import SecurSpaceContainer from '../../components/common/SecurSpaceContainer'
import BuyerInvoicesReport from '../invoices/BuyerInvoicesReport';
import InterChanges from '../interchanges/BuyerInterChangesReport';
import BuyerInventoryReport from "../buyer-inventory/BuyerInventoryReport";
import {withSnackbar} from '../../components/hocs/withSnackbar';
import {SecurSpaceReportContainer} from "../../components/common";
import {styled} from "@mui/material/styles";
import {TabContextContainer} from "../../components/common/reports/tabs/TabContextContainer";
import {TabsContainer} from "../../components/common/reports/tabs/TabsContainer";

const TabsBorderBottomGrey200 = styled(Tabs)(({theme}) => ({
  borderBottom: `${theme.palette.grey[200]} solid 0.07rem`
}));

const ReportOverview = (props) => {
  const {initialTab = 0, account, snackbarShowMessage} = props;
  const [currentTab, setCurrentTab] = useState(initialTab);

  const handleTabChange = (_event, value) => {
    setCurrentTab(value);
  }

  const filterSelectOptions = useMemo(() => filterBySelectOption(snackbarShowMessage), [snackbarShowMessage]);

  return (
      <SecurSpaceContainer>
        <SecurSpaceReportContainer>
          <TabContextContainer>
            <TabContext value={currentTab + ''}>
              <TabsContainer>
                <TabsBorderBottomGrey200
                  variant={'fullWidth'}
                  value={currentTab}
                  onChange={handleTabChange}
                  aria-label={'Report Tabs'}
                  textColor={'secondary'}
                >
                  <Tab label='Current Inventory'/>
                  <Tab label='Interchanges'/>
                  <Tab label='Invoices'/>
                  <Tab label='Space Usage'/>
                </TabsBorderBottomGrey200>
                <TabPanel value={'0'}>
                  <BuyerInventoryReport account={account} filterSelectOptions={filterSelectOptions}/>
                </TabPanel>
                <TabPanel value={'1'}>
                  <InterChanges account={account} filterSelectOptions={filterSelectOptions}/>
                </TabPanel>
                <TabPanel value={'2'}>
                  <BuyerInvoicesReport account={account}/>
                </TabPanel>
                <TabPanel sx={{
                  padding: '1.5em 0em'
                }} value={'3'}>
                  <BuyerSpaceUsageReport account={account}/>
                </TabPanel>
              </TabsContainer>
            </TabContext>
          </TabContextContainer>
        </SecurSpaceReportContainer>
      </SecurSpaceContainer>
  );
};

ReportOverview.propTypes = {
  initialTab: PropTypes.number,
  account: PropTypes.object.isRequired,
  handleLogout: PropTypes.func.isRequired,
};

export default withSnackbar(ReportOverview);
